import { Controller } from "@hotwired/stimulus"

// Polls the session status endpoint while the user is expected to place the
// inbound verification call. As soon as uCaller's callback confirms the call,
// the (button-less) confirm form is submitted automatically so the user is
// signed in without any manual step.
export default class extends Controller {
  static targets = ["form", "hint"]
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    this.submitted = false
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    this.stop()
  }

  async poll() {
    let state
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })
      if (!response.ok) return
      ;({ state } = await response.json())
    } catch (_error) {
      return // transient network issue — keep polling
    }

    if (state === "verified") {
      this.confirm()
    } else if (state === "expired" || state === "gone") {
      this.stop()
      if (this.hasHintTarget) {
        this.hintTarget.textContent = "Время проверки истекло, начните заново."
      }
    }
  }

  confirm() {
    if (this.submitted) return
    this.submitted = true
    this.stop()

    if (this.hasHintTarget) {
      this.hintTarget.textContent = "Звонок подтверждён, входим…"
    }

    if (this.hasFormTarget) {
      this.submit(this.formTarget)
    }
  }

  // Safari ниже 16 (iOS 15 — наш нижний порог в allow_browser) не знает
  // requestSubmit, а Turbo 8 полифилла для него не возит. Без запасного пути
  // здесь выбрасывался TypeError уже после stop(), и страница навсегда
  // оставалась на «Звонок подтверждён, входим…». Клик по временной кнопке
  // отправляет форму через событие submit, то есть по-прежнему через Turbo.
  submit(form) {
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
      return
    }

    const button = document.createElement("input")
    button.type = "submit"
    button.hidden = true
    form.appendChild(button)
    button.click()
    form.removeChild(button)
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
